const keyStorage = 'SIM-';
const KEYS = [
  'id',
  'username',
  'idmpleado',
];

export const storeTokens = (tokens) => {
  try {
    KEYS.forEach((key, index) => {
      localStorage.setItem(`${keyStorage}${key}`, String(tokens[key]));
      if (index === KEYS.length - 1) {
        return true
      }
    });
  } catch (err) {
    return err;
  }
};

export const retrieveCredentials = () => {
  try {
    const credentials = {};
    KEYS.forEach((key) => {
      credentials[key] = localStorage.getItem(`${keyStorage}${key}`) !== 'undefined' ? localStorage.getItem(`${keyStorage}${key}`) : null;
    });
    return credentials;
  } catch (err) {
    return err;
  }
};

export const clearCredentials = () => {
  try {
    KEYS.forEach((key, index) => {
      localStorage.removeItem(`${keyStorage}${key}`);
      if (index === KEYS.length - 1) {
        return true;
      }
    });
  } catch (err) {
    return err;
  }
};

export const storeLanguage = (leng) => {
  try {
    return localStorage.setItem('language', leng);
  } catch (err) {
    return "es-MX";
  }
};

export const retrieveLanguage = () => {
    try {
      return localStorage.getItem('language')
    } catch (err) {
      return "es-MX";
    }
};

export const clearLanguage = () => {
  try {
    localStorage.removeItem('language');
  } catch (err) {
    return err;
  }
};


export const storeMode = (option) => {
  try {
    return localStorage.setItem('theme', option);
  } catch (err) {
    return err;
  }
};


export const clearMode = () => {
  try {
    localStorage.removeItem('theme');
  } catch (err) {
    return err;
  }
};

export const retrieveMode = () => {
  try {
    return localStorage.getItem('theme')
  } catch (err) {
    return "light";
  }
};

export const storeClave = (option) => {
  try {
    return localStorage.setItem('uiid', option);
  } catch (err) {
    return err;
  }
};


export const clearClave = () => {
  try {
    localStorage.removeItem('uiid');
  } catch (err) {
    return err;
  }
};

export const retrieveClave = () => {
  try {
    return localStorage.getItem('uiid')
  } catch (err) {
    return "sin";
  }
};



